import PropTypes from 'prop-types';

export const OriginalContentType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  content: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'markdown']).isRequired,
});

export const ContentSuggestionType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  approved: PropTypes.bool,
  approvedBy: PropTypes.number,
  contentNode: PropTypes.number,
  createdAt: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  reason: PropTypes.string,
  suggestedValue: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

export const ContentSuggestionSetType = PropTypes.shape({
  originalContent: OriginalContentType.isRequired,
  suggestions: PropTypes.arrayOf(ContentSuggestionType).isRequired,
  setName: PropTypes.string,
});
